module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    class: _vm.sectionWrapperClass
  }, [_c('v-layout', {
    staticClass: "input-layout device-pairing__steps"
  }, [_c('div', {
    staticClass: "device-pairing__step"
  }, [_c('a', {
    staticClass: "device-pairing__play-store-badge__image",
    attrs: {
      "href": _vm.downloadApplicationLink
    }
  }, [_c('img', {
    staticClass: "device-pairing__step__image",
    attrs: {
      "src": _vm.getAssetsSrc('/images/app-pairing/webkey-play-store-badge.png'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "device-pairing__step__info"
  }, [_c('span', {
    staticClass: "device-pairing__step__number device-pairing__step__number--primary"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "device-pairing__step__title"
  }, [_vm._v("Install Webkey Client app to your smartphone")])])]), _vm._v(" "), _c('div', {
    staticClass: "device-pairing__step"
  }, [_c('img', {
    staticClass: "device-pairing__step__image",
    attrs: {
      "src": _vm.getAssetsSrc('/images/app-pairing/webkey-pin-code-1.png'),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "device-pairing__step__info"
  }, [_c('span', {
    staticClass: "device-pairing__step__number"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "device-pairing__step__title"
  }, [_vm._v("Tap \"Enter PIN code\" in the app")])])]), _vm._v(" "), _c('div', {
    staticClass: "device-pairing__step"
  }, [_c('img', {
    staticClass: "device-pairing__step__image",
    attrs: {
      "src": _vm.getAssetsSrc('/images/app-pairing/webkey-pin-code-2.png'),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "device-pairing__step__info"
  }, [_c('span', {
    staticClass: "device-pairing__step__number"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "device-pairing__pin"
  }, [_c('span', {
    staticClass: "device-pairing__step__title"
  }, [_vm._v("Enter PIN code:")]), _vm._v(" "), _c('span', {
    staticClass: "device-pairing__pin--text"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.pin) + "\n\t\t\t\t\t\t")]), _vm._v(" "), (_vm.pinRefreshable) ? _c('button', {
    staticClass: "device-pairing__pin__generate link link--clean link--tiny",
    on: {
      "click": function($event) {
        return _vm.renewPIN()
      }
    }
  }, [_c('svg-icon', {
    staticClass: "icon icon--tiny",
    attrs: {
      "icon": "sync"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "device-pairing__pin__generate--text"
  }, [_vm._v("Generate new PIN")])], 1) : _vm._e()])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "device-pairing__footer modal__section--flush modal__section--alternate"
  }, [_c('h3', {
    staticClass: "title--5"
  }, [_vm._v("Or pair devices via e-mail:")]), _vm._v(" "), _c('form', {
    staticClass: "device-pairing__send-link",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendInvitation()
      }
    }
  }, [_c('v-layout', {
    staticClass: "input-layout email-layout",
    attrs: {
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "left-input"
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "label": "E-mail",
      "data-vv-validate-on": "blur",
      "type": "text",
      "name": "email",
      "error-messages": _vm.errors.has('email') ? 'Enter your email' : [],
      "outlined": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "right-input button--big",
    attrs: {
      "x-large": "",
      "loading": _vm.isSendingInvitation,
      "disabled": _vm.isSendingInvitation,
      "type": "submit",
      "color": "primary"
    }
  }, [_c('svg-icon', {
    staticClass: "icon icon--white icon--smaller",
    attrs: {
      "icon": "send"
    }
  }), _vm._v("\n\t\t\t\t\t Send Pairing Link\n\t\t\t\t")], 1)], 1)], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('apierror')),
      expression: "errors.has('apierror')"
    }],
    staticClass: "input-field__error"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('apierror')) + " ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32ae8275","hasScoped":false}!./app/components/device-pairing/template.html
// module id = 378
// module chunks = 0